const getAllAirspots = (state) => (state.airspots.length ? state.airspots : [])

const obj = {
  getAllAirspots,
}

export default obj
